<template>
	<!-- CHECK TO PRINT BEGIN -->
		<div class="print section-to-print" id="posCheckClone">
			<div id="depNameClone" class="d-flex justify-content-center"><strong>DwPos - {{ currentSaleForCheck.shopName }}</strong>
			</div>
			<div id="depAddressClone" class="d-flex justify-content-center bottom-bordered"><i>{{ currentSaleForCheck.shopAddress }}</i>
			</div>
			<div class="d-flex justify-content-between"><span>{{ currentSaleForCheck.saleDate }}</span> <span style="text-align: right;">{{$t('sidebar.pos.check')}}: {{ currentSuspendId ? currentSaleSuspendNumber : currentSaleNumber
				}}</span>
			</div>
			<div class="d-flex justify-content-between"><span>{{$t('xAtchot.cashier')}}:{{ currentSaleForCheck.cashierFullName }}</span>
				<span
					style="text-align: right;">POS №:{{ cashboxNumber }}</span></div>
			<div class="d-flex justify-content-between"
				 :class="returnItemsCount == 0 ? 'bottom-bordered' : ''"
			><span>{{$t('pos.saller')}}:{{ currentSaleForCheck.sellerName }}</span>
				<span style="text-align: right;">{{$t('pos.items')}}:{{ totalCount }}</span></div>
			<div
				v-if="returnItemsCount !== 0"
				class="d-flex justify-content-end bottom-bordered">
				<span style="text-align: right;">Возврат кол-во:{{ returnItemsCount }}</span>
			</div>
			<div class="posCheckTable bottom-bordered">
				<table>
					<thead>
					<tr>
						<th class="alignedLeft" style="width: 45%; word-break: break-all;">{{$t('sale.products')}}</th>
						<th class="alignedCenter" style="width: 17%; word-break: break-all;">{{$t('sale.kol-vo')}}</th>
						<th class="alignedCenter" style="width: 17%; word-break: break-all;">{{$t('sidebar.pos.sale')}}</th>
						<th class="alignedRight" style="width: 32%; word-break: break-all;">
							{{$t('incomes.create.price')}} ({{userDepCurrencyName}})
						</th>
					</tr>
					</thead>
					<tbody>
					<tr
						v-for="(item, index) in currentSaleForCheck.saleItems"
						:key="'checkItem' + index"
						:class="item.count < 0 ? 'returnItemBordered' : ''"
					>
						<td class="alignedLeft" style="width: 45%; word-break: break-all;">
							<strong>{{ index + 1 }}.</strong>{{ item.name }}/<strong>{{item.artikul}}</strong>/{{item.genderName
							}}/{{
							item.colorName }}/<strong>{{ item.size }}</strong>
						</td>
						<td class="alignedCenter" style="width: 17%; word-break: break-all;">
							{{ item.count > 0 ? item.count : -item.count }}
						</td>
						<td class="alignedCenter" style="width: 17%; word-break: break-all;">
							<template v-if="afterPromotionSum(item) > 0">
								{{ afterPromotionSum(item) | currency({
										symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
									})
								}}
							</template>
							<template v-else-if="afterPromotionPercentage(item) > 0">
								{{ afterPromotionPercentage(item) | currency({
										symbol: '%', symbolPosition: 'back'
									})
								}}
							</template>
							<template v-else> - </template>
						</td>
						<td class="alignedRight" style="width: 32%; word-break: break-all;">
							{{ item.discountPriceUzs * item.count | currency({
							symbol: '', fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							})}}<br>{{ item.priceUzs * item.count | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ''})}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="posCheckTotal bottom-bordered">
				<table>
					<tbody>
					<tr>
						<td class="alignedLeft">{{$t('warehouse.table.totalIncomeUzs')}}</td>
						<td class="alignedRight">{{ currentSaleForCheck.amountOfAfterPromoUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('pos.ndc')}}</td>
						<td class="alignedRight">{{ currentSaleForCheck.amountOfAfterPromoUzs/6 | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('xAtchot.pay')}}</td>
						<td class="alignedRight">{{ currentSaleForCheck.amountOfAfterPromoUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('sale.payed')}}</td>
						<td class="alignedRight">{{ totalPaid | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr v-if="returnItemsSum !== 0" class="returnItemBordered">
						<td class="alignedLeft">ВОЗВРАТ</td>
						<td class="alignedRight">{{ -returnItemsSum | currency({
							symbol: userDepCurrencyName, fractionCount: 2,
							symbolPosition:
							'back', thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr v-if="parseInt(computedSponsorshipAmount) > 0" class="returnItemBordered">
						<td class="alignedLeft">{{$t('sidebar.sales.sponsor')}}</td>
						<td class="alignedRight">{{ computedSponsorshipAmount | currency({symbol: userDepCurrencyName,
							fractionCount: 2,
							symbolPosition:
							'back', thousandsSeparator: ''}) }}
						</td>
					</tr>
					<tr v-if="parseInt(computedDebtAmount) > 0">
						<td class="alignedLeft">ДОЛГ</td>
						<td class="alignedRight">{{ computedDebtAmount | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('pos.no-check')}}</td>
						<td class="alignedRight" v-if="currentSaleForCheck.customPromotionDiscount">
							{{ currentSaleForCheck.customPromotionDiscount }}
							<span v-if="currentSaleForCheck.customPromotionType == '%'">{{ currentSaleForCheck.customPromotionType }}</span>
							<span v-else>{{ userDepCurrencyName }}</span>
						</td>
						<td class="alignedRight" v-else>{{ 0 | currency({
							symbol: '',
							symbolPosition: 'back', thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<!-- IF ISONLINE PRODAJA CHEKED -->
			<div v-if="currentSaleForCheck.orderNumber"  class="posCheckTotalB bottom-bordered">
				<table >
					<tbody >
					<tr >
						<td class="alignedLeft">Номер заказа</td>
						<td class="alignedRight">
							{{currentSaleForCheck.orderNumber}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">Клиент</td>
						<td class="alignedRight">
							{{currentSaleForCheck.clientName}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">Контактный номер</td>
						<td class="alignedRight">
							{{currentSaleForCheck.clientPhoneNumber}}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">Адрес доставки</td>
						<td class="alignedRight">
							{{currentSaleForCheck.clientAddress}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="posThanks">
				<p><i>-- {{$t('pos.please')}}! --</i></p>
			</div>
		</div>
		<!-- CHECK TO PRINT END -->
</template>

<script>
	import { mapState } from 'vuex';
	import {TokenService} from "../../../../services/storage.service";

	export default {
		name: 'PosCheck',
		data: () => {
			return {
				cashboxNumber: localStorage.getItem('cash_number'),
			}
		},
		computed: {
			...mapState(['userDepCurrencyName']),
			...mapState('pos', [
				'clientPhoneNumber','clientName', 'orderNumber','clientAddress' ,'isOnlaynProdaja',
				'totalSum', 'checkPage', 'realTotalSum', 'comment',
				'shopName', 'currentSaleNumber',
				'currentSaleId', 'balanceItems',
				'shopAddress', 'cashierFullName', 'currentSellerName', 'sellerId',
				'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'errorOccur',
				'searchLoading', 'saleFinishError', 'saleFinishLoading',
				'isReturn', 'currentSaleForCheck'
			]),
			totalCount() {
				let count = 0;
				if (this.currentSaleForCheck.saleItems) {
					for (let i = 0; i < this.currentSaleForCheck.saleItems.length; i++) {
						count += this.currentSaleForCheck.saleItems[i].count;
					}
				}
				return count;
			},
			totalPaid() {
				if (this.currentSaleForCheck.payments) {
					return this.currentSaleForCheck.payments.reduce(function (prev, cur) {
						if (cur.value.toString().trim() !== '' && cur.paymentTypeCode !== 'QARZGA' && cur.paymentTypeCode !== 'HOMIYLIK') {
							return prev + parseInt(cur.value);
						} else {
							return prev
						}
					}, 0);
				} else {
					return 0;
				}

			},
			computedDebtAmount() {
				if (this.currentSaleForCheck.payments) {
					if (this.currentSaleForCheck.payments.length > 0) {
						return this.currentSaleForCheck.payments.find(el => el.paymentTypeCode == 'QARZGA') ? this.payments.find(el => el.paymentTypeCode == 'QARZGA').value : 0;
					}
				}
				return 0;
			},
			computedSponsorshipAmount() {
				if (this.currentSaleForCheck.payments) {
					if (this.currentSaleForCheck.payments.length > 0) {
						return this.currentSaleForCheck.payments.find(el => el.paymentTypeCode == 'HOMIYLIK') ? this.currentSaleForCheck.payments.find(el => el.paymentTypeCode == 'HOMIYLIK').value : 0;
					}
				}
				return 0;
			},
			returnItemsSum() {
				let sum = 0;
				if (this.currentSaleForCheck.saleItems) {
					this.currentSaleForCheck.saleItems.forEach(el => {
						if (el.count < 0) {
							sum += el.count * el.discountPriceUzs;
						}
					});
				}

				return sum;
			},
			returnItemsCount() {
				let count = 0;
				if (this.currentSaleForCheck.saleItems) {
					this.currentSaleForCheck.saleItems.forEach(el => {
						if (el.count < 0) {
							count -= el.count;
						}
					});
				}
				return count;
			},
		},
		methods: {
			afterPromotionSum(item) {
				let promoparam;
				if (item.promotions) {
					for (let i = 0; i < item.promotions.length; i++) {
						if (item.promotions[i].type == "PUL") {
							promoparam = item.promotions[i].value
						}
					}
					return promoparam;
				}
			},

			afterPromotionPercentage(item) {
				let promoparam1;
				if (item.promotions) {
					for (let i = 0; i < item.promotions.length; i++) {
						if (item.promotions[i].type == "%") {
							promoparam1 = item.promotions[i].value
						}
					}
					return promoparam1;
				}
			}
		}
	}
</script>

<style scoped lang="scss">
// @import url('https://fonts.googleapis.com/css?family=Inconsolata');

	.print {
		display: none;
	}

	@media print {
		// @page {
		// 	size: portrait;
		// }
		.hidden-print {
			display: none;
		}
		.print {
			color: #000000;
			display: block;
		}
		.card {
			box-shadow: none;
		}
	}

	.posCustomModalHeader {
		display: flex;
		width: 100%;
		justify-content: space-between;

		.close {
			font-size: 14px;
		}
	}

	p {
		margin-bottom: 0;
	}

	.foundProduct {
		&.disabled {
			background-color: #eeeeee;
		}

		&.selected {
			background-color: #ccc;
		}
	}

	.input-group-text#for-barcode {
		padding: 0;

		.input-group-addon.barcode-refresh {
			padding: 0.575rem 0.75rem;

			&:active {
				border: .5px solid #dddddd;
			}
		}
	}

	.lastElemet {
		display: flex;
		justify-content: flex-end;
		margin-right: 25px;
	}

	#searchResult {
		display: none;
		position: absolute;
		top: 100%;
		width: 92.25%;
		border: 1px solid #c5c5c5;
		left: 4.05%;
		background: #ffffff;
		z-index: 101;
		max-height: 29rem;
		min-height: 80px;
		overflow-x: auto;

		.posItemImage {
			width: 40px;
			height: auto;
			object-fit: cover;
			margin: 0 10px 0 5px;
		}

		.foundProduct {
			padding: 10px;
			cursor: pointer;

			&:hover {
				background: #ccc;
			}

			.productName {
				padding-right: 1rem;
				font-size: 12px;
			}

			.productPrice {
				font-size: 13px;
				width: 32%;
			}

			.productBreadcrumb {
				font-size: 12px;
				color: #888;
			}
		}
	}

	@media (min-width: 1624px) {
		#searchResult {
			width: 93.495%;
			left: 3.41%;
		}
	}

	#posProducts {
		margin-top: 20px;
		max-height: 24rem;
		overflow-x: auto;
	}

	#overallAndButtons {
		.posFooterTable {
			.d-inline-table {
				display: inline-table;
			}
		}

		#posButtons {
			padding-top: 10px;
			padding-bottom: 10px;
			display: flex;
			justify-content: space-between;
		}
	}

	.alignedLeft {
		text-align: left;
	}

	.alignedRight {
		text-align: right;
	}

	.alignedCenter {
		text-align: center;
	}

	#posCheckClone {
		width: 100mm;
		background: white;
		padding: 10px;
		font-family: monospace;
		font-size: 14px;
		font-weight: bold;
		color: #000000 !important;

		#depNameClone {
			font-size: 18px;
		}

		.bottom-bordered {
			padding-bottom: 2px;
			border-bottom: .5px dashed #444;
		}

		table {
			width: 100%;
		}
sales
		.returnItemBordered {
			border: .5px dotted black;
		}

		td, th {
			border: none;
			font-size: 12px;
			padding: 2px;
			color: #000000;
			vertical-align: top !important;
		}

		.table {
			td, th {
				vertical-align: top;
			}
		}

		.posCheckTotal {
			table {
				td {
					font-weight: bold;
					font-size: 14px;
				}
			}
		}
		.posCheckTotalB {
			table {
				td {
					font-weight: bold;
					font-size:12px;
				}
			}
		}
		.posThanks {
			p {
				text-align: center;
				font-weight: bold;
				font-size: 14px;
			}
		}
	}
</style>
